import {memo, useCallback} from 'react'

import PropTypes from 'prop-types'

import AtomCard from '@s-ui/react-atom-card'

import CardRelatedAdContent, {cardRelatedAdContactTypes, cardRelatedAdLeadTargets} from './card-related-ad-content.js'
import CardRelatedAdMedia from './card-related-ad-media.js'
import useCardRelatedAdClick from './use-card-related-ad-click.js'

const getContent =
  ({ad, contactType, extendedTrackingData, hasCriteoEvents, leadTarget, onContact}) =>
  () =>
    (
      <CardRelatedAdContent
        ad={ad}
        contactType={contactType}
        extendedTrackingData={extendedTrackingData}
        hasCriteoEvents={hasCriteoEvents}
        leadTarget={leadTarget}
        onContact={onContact}
      />
    )

const CardRelatedAd = ({
  ad,
  contactType = cardRelatedAdContactTypes.none,
  extendedTrackingData = {},
  hasCriteoEvents = false,
  hasFavouriteAction = false,
  isClickableCard = false,
  leadTarget = cardRelatedAdLeadTargets.relatedVehicle,
  onClickCard = () => {},
  onContact = () => {},
  position = 0,
  pageNameOrigin = '',
  pageType = '',
  listType = ''
}) => {
  const isContactable = contactType !== cardRelatedAdContactTypes.none
  const isClickable = !isContactable || isClickableCard

  const {imgUrl, title} = ad

  const AtomCardMedia = useCallback(
    () => (
      <CardRelatedAdMedia
        src={imgUrl}
        alt={title}
        ad={ad}
        extendedTrackingData={extendedTrackingData}
        hasFavouriteAction={hasFavouriteAction}
      />
    ),
    [imgUrl, title, ad, extendedTrackingData, hasFavouriteAction]
  )

  const handleClick = useCardRelatedAdClick({
    ad,
    extendedTrackingData,
    listType,
    onClickCard,
    pageNameOrigin,
    pageType,
    position
  })

  return (
    <div className="mt-CardRelatedAd">
      <AtomCard
        content={getContent({
          ad,
          contactType,
          extendedTrackingData,
          hasCriteoEvents,
          leadTarget,
          onContact
        })}
        media={AtomCardMedia}
        onClick={() => handleClick({shouldNavigate: isClickable})}
        vertical
      />
    </div>
  )
}

CardRelatedAd.displayName = 'CardRelatedAd'

CardRelatedAd.propTypes = {
  ad: PropTypes.object.isRequired,
  contactType: PropTypes.oneOf(Object.values(cardRelatedAdContactTypes)),
  extendedTrackingData: PropTypes.object,
  hasCriteoEvents: PropTypes.bool,
  hasFavouriteAction: PropTypes.bool,
  isClickableCard: PropTypes.bool,
  leadTarget: PropTypes.oneOf(Object.values(cardRelatedAdLeadTargets)),
  onClickCard: PropTypes.func,
  onContact: PropTypes.func,
  position: PropTypes.number,
  pageNameOrigin: PropTypes.string,
  pageType: PropTypes.string,
  listType: PropTypes.string
}

const MemoCardRelatedAd = memo(CardRelatedAd)
MemoCardRelatedAd.displayName = 'MemoCardRelatedAd'

export {default as CardRelatedAdV2} from './v2/index.js'
export {cardRelatedAdContactTypes, cardRelatedAdLeadTargets}
export default MemoCardRelatedAd
